import React, { Component } from 'react';
import { Route, Switch } from 'react-router';

import * as Pages from './pages';
import WithSecurity from './common/Security/WithSecurity';
import { RoutesStyleGuide } from './routes-styleguide';

const render = (Component, props) => {
  return () => <Component {...props} />;
};

class Routes extends Component {
  componentDidUpdate() {
    this.props.setPageLevelDirty(false);
    if (this.props.scrollMainTo) {
      this.props.scrollMainTo(0, 0);
    }
  }

  render() {
    const { props } = this;
    return (
      <Switch>
        <Route exact path="/" render={render(Pages.Login, props)} />
        {Object.keys(Pages).map(page => {
          const path = Pages[page].hasOwnProperty('path')
            ? Pages[page].path
            : `/${page.toLowerCase()}`;

          const exact = Pages[page].hasOwnProperty('exact')
            ? Pages[page].exact
            : true;

          /**
           * Give a unique key to the route based on the current route
           * Clicking a <Link /> triggers a @@router/LOCATION_CHANGE
           * generates a new key for the router, even if the user is on the same path
           * The Route's key will change thus leading to a remount of the same page
           *
           * To override this behavior, set a routeKey
           */
          const locationKey = props.history.location.key;
          const routeKey = Pages[page].hasOwnProperty('routeKey')
            ? Pages[page].routeKey
            : `/${page.toLowerCase()}${locationKey}`;

          return (
            <Route
              exact={exact}
              key={routeKey}
              path={path}
              render={() => <WithSecurity component={Pages[page]} {...props} />}
            />
          );
        })}
        <Route
          exact={false}
          path="/styleguide"
          render={render(RoutesStyleGuide, props)}
        />
        <Route exact path="/notfound" render={render(Pages.NotFound, props)} />
        <Route path="*" render={render(Pages.NotFound, props)} />
      </Switch>
    );
  }
}

export { Routes };



// WEBPACK FOOTER //
// ./src/routes.js